import { render } from "./PagesIntro.vue?vue&type=template&id=ffbd6026"
import script from "./PagesIntro.vue?vue&type=script&lang=js"
export * from "./PagesIntro.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__